import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAppTranslationsQueryVariables = Types.Exact<{
  app_type: Types.AppTranslationAppType;
}>;


export type GetAppTranslationsQuery = { __typename?: 'Query', getAppTranslations: Array<{ __typename?: 'AppTranslationEntry', id: string, name: string, url: string, created_at: string, updated_at: string }> };


export const GetAppTranslationsDocument = gql`
    query getAppTranslations($app_type: AppTranslationAppType!) {
  getAppTranslations(app_type: $app_type) {
    id
    name
    url
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetAppTranslationsQuery__
 *
 * To run a query within a React component, call `useGetAppTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppTranslationsQuery({
 *   variables: {
 *      app_type: // value for 'app_type'
 *   },
 * });
 */
export function useGetAppTranslationsQuery(baseOptions: Apollo.QueryHookOptions<GetAppTranslationsQuery, GetAppTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppTranslationsQuery, GetAppTranslationsQueryVariables>(GetAppTranslationsDocument, options);
      }
export function useGetAppTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppTranslationsQuery, GetAppTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppTranslationsQuery, GetAppTranslationsQueryVariables>(GetAppTranslationsDocument, options);
        }
export type GetAppTranslationsQueryHookResult = ReturnType<typeof useGetAppTranslationsQuery>;
export type GetAppTranslationsLazyQueryHookResult = ReturnType<typeof useGetAppTranslationsLazyQuery>;
export type GetAppTranslationsQueryResult = Apollo.QueryResult<GetAppTranslationsQuery, GetAppTranslationsQueryVariables>;